/** Time the user may leave the app before biometric unlock is required again. */
export const BIOMETRIC_LOCK_GRACE_MS = 60_000;

/**
 * True when the user returned before the lock timeout elapsed.
 * `leftAtMs === null` means this session never recorded leaving.
 */
export function isWithinBiometricLockGrace(
    leftAtMs: number | null,
    nowMs: number,
    graceMs: number = BIOMETRIC_LOCK_GRACE_MS,
): boolean {
    if (leftAtMs == null) {
        return true;
    }

    return nowMs - leftAtMs < graceMs;
}
